import { useEffect, useId, useRef, useState } from 'react';

export function MermaidDiagram({ chart }: { chart: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const id = useId().replace(/[^a-zA-Z0-9]/g, '');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const mermaid = (await import('mermaid')).default;
        mermaid.initialize({ startOnLoad: false, securityLevel: 'strict' });
        const { svg } = await mermaid.render(`mmd-${id}`, chart);
        if (!cancelled && ref.current) ref.current.innerHTML = svg;
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();
    return () => { cancelled = true; };
  }, [chart, id]);

  if (failed) {
    return <pre data-mermaid className="mb-3 overflow-x-auto rounded bg-slate-900 p-3 text-xs text-slate-100">{chart}</pre>;
  }
  return <div data-mermaid ref={ref} className="my-3 flex justify-center" aria-label="diagram" />;
}
